import type { ValueType } from '../constants'
import type {
	FieldConfig,
	FieldType,
	Localization,
	OperationOption,
} from '../types'

export type ValidateSignature = (value: any) => string | null
export type InitialValueSignature = () => any
export type HasValueSignature = (value: any) => boolean
export type FilterTypesSignature = () => OperationOption[]
/**
 * The base class for all field controllers.
 */
export default class FieldController {
	constructor(config: FieldConfig) {
		this.config = config
		this.key = config.key
		this.label = config.label
		this.type = config.type
		this.valueType = config.valueType
		this.validate = config.validate || this.defaultValidate
		this.getInitialValue = config.getInitialValue || this.getInitialValue
		this.placeholder = config.placeholder
		this.locale = config.locale

		if (!this.label) {
			throw Error(`"${this.key}" requires a label.`)
		}
	}

	// The localization for the field
	locale: Localization
	// Configuration object for the field
	config: FieldConfig

	// The key of the field in the query
	key: string

	// A note to display below the field in the UI
	note?: string

	// The label of the field in the UI
	label: string

	// The placeholder text for the field in the UI
	placeholder?: string

	// The validation function for the field
	validate: ValidateSignature

	// The type of the field
	type: FieldType

	// The type of the value of the field
	valueType: ValueType

	hasValue?: HasValueSignature = () => {
		throw Error(
			`Missing \`hasValue\` method in the "${this.type.name}" controller.`
		)
	}

	getInitialValue: InitialValueSignature = () => {
		throw Error(
			`Missing \`getInitialValue\` method in the "${this.type.name}" controller.`
		)
	}
	getFilterTypes = (): OperationOption[] => []
	defaultValidate: ValidateSignature = () => null
}
